import React from 'react';
import { Link } from 'react-router-dom';
import './About.css';

export default function About() {
  return (
    <div className="about-page page-enter">
      <div className="inner-hero" style={{ backgroundImage: "url('https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?w=1600&q=80')" }}>
        <div className="inner-hero__overlay" />
        <div className="container inner-hero__content">
          <p className="eyebrow">Our Story</p>
          <h1 className="display-title light">About Maggi Cabs</h1>
          <div className="amber-line" />
          <p>20+ years of safe, trusted travel on the Kodai Road to Kodaikanal route.</p>
        </div>
      </div>

      {/* Owner Story */}
      <section className="section-pad container">
        <div className="about-grid">
          <div className="about-img-wrap">
            <img src="https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=700&q=80" alt="Kodaikanal Mountains" />
            <div className="about-owner-card">
              <strong>Anbu Kumar</strong>
              <span>Founder & Owner</span>
              <span>📞 +91 9445879508</span>
              <span>Est. 2003</span>
            </div>
          </div>
          <div className="about-text">
            <p className="eyebrow">Founded 2003</p>
            <h2 className="display-title">Meet Anbu Kumar —<br /><em style={{color:'var(--forest)',fontStyle:'italic'}}>Your Trusted Guide</em></h2>
            <div className="amber-line" />
            <p>Anbu Kumar started Maggi Cabs in 2003 with a simple mission: to provide safe, reliable, and affordable taxi service from Kodai Road Railway Station to the beautiful hill station of Kodaikanal.</p>
            <p>With over 20 years of experience navigating the winding ghat roads of the Palani Hills, Anbu Kumar has built a reputation for punctuality, honesty, and genuine care for his passengers. Thousands of families, couples, and groups have trusted him with their most cherished travel memories.</p>
            <p>Today, Maggi Cabs operates a fleet of 4 vehicle types — from 4-seater cars for couples to 25-seater coaches for large groups — all maintained to the highest safety standards.</p>
            <div className="about-stats">
              {[['2003', 'Est.'], ['20+', 'Years'], ['10,000+', 'Trips'], ['4', 'Vehicles']].map(([n, l]) => (
                <div key={l} className="about-stat">
                  <strong>{n}</strong><span>{l}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="section-pad about-values">
        <div className="container">
          <div className="text-center">
            <p className="eyebrow">Why We're Different</p>
            <h2 className="display-title">Our Commitments</h2>
            <div className="amber-line center" />
          </div>
          <div className="values-grid">
            {[
              { icon:'🛡️', title:'Safety First',     desc:'All vehicles are regularly serviced. Experienced drivers with full knowledge of mountain ghat roads.' },
              { icon:'⏰', title:'Always Punctual',  desc:'We understand your train timings and schedules. Pick-up is never late — guaranteed.' },
              { icon:'💰', title:'Fair Pricing',     desc:'Transparent, honest pricing. No hidden charges. What we quote is what you pay.' },
              { icon:'📞', title:'24/7 Available',   desc:'Available round the clock. Call or WhatsApp anytime — even for late-night station pickups.' },
              { icon:'🏔️', title:'Local Expertise',  desc:'20+ years on the Kodai route means we know every shortcut, viewpoint and hidden gem.' },
              { icon:'✨', title:'Personal Touch',   desc:'You deal directly with Anbu Kumar — not a call centre. Personal service every trip.' },
            ].map(v => (
              <div key={v.title} className="value-card card">
                <span className="value-card__icon">{v.icon}</span>
                <h3>{v.title}</h3>
                <p>{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Route Info */}
      <section className="section-pad container">
        <div className="route-section">
          <div>
            <p className="eyebrow">Our Route</p>
            <h2 className="display-title">Kodai Road ↔ Kodaikanal</h2>
            <div className="amber-line" />
            <p>The journey from Kodai Road to Kodaikanal is approximately 80 km, climbing from the plains at 300m elevation to the hilltop at 2,133m above sea level. The route passes through beautiful ghat sections with stunning views.</p>
            <p>Drive time: <strong>1.5 to 2 hours</strong> depending on traffic and weather. Our drivers know this road in all conditions — rain, mist, or sunshine.</p>
          </div>
          <div className="route-map-placeholder">
            <div className="route-card">
              <div className="route-point start">🚉 Kodai Road<br/><small>Railway Station</small></div>
              <div className="route-road">
                <span>↓</span>
                <small>80 km · ~2 hrs</small>
                <span>↓</span>
              </div>
              <div className="route-point end">🏔️ Kodaikanal<br/><small>2,133m altitude</small></div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="section-pad container" style={{textAlign:'center'}}>
        <p className="eyebrow">Start Your Journey</p>
        <h2 className="display-title">Ready to Book?</h2>
        <div className="amber-line center" />
        <p style={{color:'#666', marginBottom:'2rem'}}>Call or WhatsApp Anbu Kumar directly — no middlemen, no booking fees.</p>
        <div style={{display:'flex',gap:'1rem',justifyContent:'center',flexWrap:'wrap'}}>
          <a href="tel:+919445879508" className="btn-primary">📞 Call +91 9445879508</a>
          <a href="https://wa.me/919445879508" target="_blank" rel="noreferrer" className="btn-green">💬 WhatsApp Now</a>
        </div>
      </section>
    </div>
  );
}
